import { employees } from "../data/generated";
import type { AnomalyDefinition, GeneratedMail, MailTemplate } from "../types";

function unique(values: string[]): string[] {
  return [...new Set(values)];
}

export function isAnomalyCompatible(mail: MailTemplate, anomaly: AnomalyDefinition): boolean {
  if (anomaly.compatibleCategories.length > 0 && !anomaly.compatibleCategories.includes(mail.category)) {
    return false;
  }
  if (mail.tags.some((tag) => anomaly.incompatibleTags.includes(tag))) {
    return false;
  }
  return true;
}

export function applyAnomaly(mail: MailTemplate, anomaly: AnomalyDefinition): GeneratedMail {
  const patch = anomaly.apply;
  const senderId = patch.senderId ?? mail.senderId;
  const toIds = unique([...mail.toIds, ...(patch.addToIds ?? [])]);
  const ccIds = unique(
    [...mail.ccIds.filter((id) => !(patch.removeCcIds ?? []).includes(id)), ...(patch.addCcIds ?? [])]
  );

  return {
    ...mail,
    senderId,
    toIds,
    ccIds,
    subject: patch.subjectReplace ?? `${patch.subjectPrefix ?? ""}${mail.subject}${patch.subjectAppend ?? ""}`,
    body: patch.bodyReplace ?? `${mail.body}${patch.bodyAppend ?? ""}`,
    signatureId: patch.signatureId ?? mail.signatureId,
    sentAt: patch.sentAtOverride ?? mail.sentAt,
    attachmentIds: patch.attachmentIds ?? mail.attachmentIds,
    variantId: `${mail.id}::${anomaly.id}`,
    isAnomaly: true,
    anomalyId: anomaly.id,
    anomalyType: anomaly.type,
    debugExplanation: anomaly.explanation,
    senderEmailOverride: patch.senderEmailOverride,
    senderNameOverride: patch.senderNameOverride,
    senderDepartmentOverride: patch.senderDepartmentOverride,
    signatureExtensionOverride: patch.signatureExtensionOverride,
    sentAtDisplayOverride: patch.sentAtDisplayOverride,
    uiMutationId: patch.uiMutationId,
    portalMutationId: patch.portalMutationId,
    directoryMutationId: patch.directoryMutationId,
    manualMutationId: patch.manualMutationId
  };
}

export function createNormalMail(mail: MailTemplate): GeneratedMail {
  return {
    ...mail,
    variantId: `${mail.id}::normal`,
    isAnomaly: false
  };
}

export function getEmployee(id: string) {
  return employees.find((employee) => employee.id === id);
}
